import React, {useEffect} from 'react'
import PSICodeLogModule from '../../components/Measures/PSICodeLog';

const PSICodeLog = () => {
    useEffect(() => {
        // Update the document title using the browser API
        document.title = `AHRQ QI: PSI Log of Coding Updates and Revisions`;
      });
    return (<>
    <PSICodeLogModule />
    </>)
}

export default PSICodeLog;